(function () {
    "use strict";

    var INITIAL_FONT_SIZE_HASH = 'initial-font-size';

    function changeDocumentFont(fontSize) {
        window.document.documentElement.style.fontSize = (fontSize / 16) + 'rem';
    }

    function getFontSizeFromHash() {
        var pattern = new RegExp(INITIAL_FONT_SIZE_HASH + '=(\\d+)', 'i');
        var match = window.location.hash.match(pattern);

        if (match && match[1]) {
            return parseInt(match[1]);
        }

        return null;
    }

    function init() {
        var fontSizeFromHash = getFontSizeFromHash();

        if (fontSizeFromHash > 0) {
            changeDocumentFont(fontSizeFromHash);
        }
    }

    init();
}) ();

